
import { defineComponent, ref, computed } from 'vue'
import { useStore } from '@/store'
import localCache from '@/utils/cache'
import { useRouter } from 'vue-router'
export default defineComponent({
  name: 'nav-info',
  setup() {
    const store = useStore()
    const router = useRouter()
    //获取用户名
    const userName = computed(() => store.state.login.userInfo.name)
    /* 退出登录 */
    const handleExitClick = () => {
      localCache.delCache('token')
      router.push('/login')
    }
    return {
      userName,
      handleExitClick
    }
  },
  components: {}
})
